
type PropertyValToCheck = boolean | string | number | ((element:any,index?:number, array?:[]) => boolean);

import { Pipe, PipeTransform } from '@angular/core';

/**
 * @ngModule RISCommonModule
 * @description
 * Gets a array of an objects,property and value and ref to a result object that will indicate if an object with the specified value
 * in the specified property exists in any of the objects in the collection
 * **The input array remains unchanged and returns as is**

 * @param items - the array of objects to check.
 * @param propertiesMap - a map of object properties (keys) to check against searched values (the value can be string,num,boolean
 * or a function in following shape:  * ((element:any,index?:number, array?:[]) => boolean
 * @param searchedPropertiesExistenceObject - an key / value pairs collection of  properties and boolean values
 * **It is important to pass an initialized empty object ({}) of type Record **
 *  - **This object is used to return to the client code the indication for each of properties if its searched value exists in the array**.<br>
 * @returns An array of the items unchanged
 * @example -
 * 1.in the using component define as a class field an object that will return the results:
 *   public propertiesExistenceObject : Record<string, boolean> = {};
 * 2.in the using component define the map of properties with their corresponding expected values
 * public propertiesToCheckMap:Map<string,PropertyValToCheck>;
 * private initPropertiesToCheckMap(){
 * 		this.propertiesToCheckMap = new Map<string, PropertyValToCheck>();
 * 		this.propertiesToCheckMap.set("isSelected",true);
 * 		this.propertiesToCheckMap.set("worklistThresholdLevel1Class",this.checkIsItemWithhresholdLevel1Class);
 * 		this.propertiesToCheckMap.set("worklistThresholdLevel2Class",this.checkIsItemWithhresholdLevel2Class);
 * 	}
 * 2.in the component template
 * <cp-worklist-navigation-icon-item
 *      *ngFor="let iconItem of worklistNavigationIcons| slice:(worklistNavigationIcons.length-hiddenItemsNum)
 * 					 |cpAnyItemWithSpecifiedPropertiesValues:propertiesToCheckMap:propertiesExistenceObject;trackBy:worklistNavigationIconsTrackBy"
 */
@Pipe({
	name: 'cpAnyItemWithSpecifiedPropertiesValues',
	pure: true
})
export class AnyItemWithSpecifiedPropertiesValuesPipe implements PipeTransform {


	transform(items: object[],propertiesMap:Map<string,PropertyValToCheck> ,searchedPropertiesExistenceObject : Record<string, boolean>): any[] {

		propertiesMap.forEach((paramValueOrCheckFunction: any, propertyName: string) => {
			let resultForProperty = false;

			if (!(paramValueOrCheckFunction instanceof Function)){
				const propertyValue = paramValueOrCheckFunction;
				if (items.some(item => item[propertyName] === propertyValue)) {
					resultForProperty = true;
				}
			}else{
				const checkFunction = paramValueOrCheckFunction;
				if (items.some(checkFunction)) {
					resultForProperty = true;
				}
			}
			searchedPropertiesExistenceObject[propertyName] = resultForProperty;
		});
		let check = searchedPropertiesExistenceObject;
		return items;

	}

}

